import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'

export type PatientData = {
  [key: string]: any // to allow flexibility for additional fields
}

export type PatientState = {
  data: PatientData | null
  lastUpdated: string | null
  isLoading: boolean
}

const initialState: PatientState = {
  data: null,
  lastUpdated: null,
  isLoading: false,
}

const OpdPatientSlice = createSlice({
  name: 'Patient',
  initialState,
  reducers: {
    setOpdPatientData: (state, action: PayloadAction<PatientData>) => {
      state.data = action.payload
      state.lastUpdated = new Date().toISOString()
    },
    updatePatientData: (state, action: PayloadAction<Partial<PatientData>>) => {
      state.data = { ...state.data, ...action.payload }
      state.lastUpdated = new Date().toISOString()
    },
    clearPatientData: (state) => {
      state.data = null
      state.lastUpdated = new Date().toISOString()
    },
    setPatientLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
  },
})

export const {
  setOpdPatientData,
  updatePatientData,
  clearPatientData,
  setPatientLoading,
} = OpdPatientSlice.actions

// Selectors
export const selectPatientData = (state: RootState) =>
  state?.SelectedOpdPatient?.data
export const selectPatientIsLoading = (state: RootState) =>
  state?.SelectedOpdPatient?.isLoading
export const selectPatientLastUpdated = (state: RootState) =>
  state?.SelectedOpdPatient?.lastUpdated

export default OpdPatientSlice.reducer
